import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {toggleBoxLoading} from "../actions";
import BoxTitle from "../components/BoxTitle";
import BoxInput from "../components/BoxInput";
import BoxValidateButton from "../components/BoxValidateButton";
import classNames from "classnames";
import {onElementAppear, onElementExit} from '../utils'
import {Flipped} from "react-flip-toolkit";

class PartReferenceBox extends Component{
    constructor(props) {
        super(props);

        this.state = {
            searchValue : ""
        }
    }

    handleInputChange(e) {
        this.setState({searchValue: e.target.value});
    }

    handleKeyPress(e) {
        if(e.keyCode == 13){
            this.validate();
        }
    }

    handleValidate() {
        this.validate();
    }

    validate() {
        if (this.state.searchValue) {
            this.props.toggleBoxLoading('partReference');
            window.location = '/recherche-piece?ref='+this.state.searchValue;
        }
    }

    render() {
        let bActive=this.props.activeTab === 'part_reference';
        const containerClasses = classNames(
            'part_reference_box',
            {
                'loading': this.props.statuses.partReference.loading,
                'completed' : this.props.completed && HIDE_INFORMATION_BOX !== 'category',
                'active' : this.props.activeTab === 'part_reference'
            }
        );

        return (
            <Flipped
                flipId={`part_reference_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`part_reference_box`}
                delay={3}
            >
                <div className={containerClasses}>
                    <BoxTitle title="Rechercher une pièce par sa référence"/>
                    <div className="form_input_group">
                    <BoxInput changeAction={(e) => this.handleInputChange(e)} keyDownAction={(e) => this.handleKeyPress(e)} value={this.state.searchValue} placeholder={"X53/B01"} autoFocus={bActive}  focus={bActive}/>
                        <span>
                            <i className="material-icons">
                                search
                            </i>
                            <p className="small">
                                123
                            </p>
                        </span>
                        <BoxValidateButton clickAction={(e) => this.handleValidate()}/>
                    </div>

                    {this.props.statuses.partReference.loading ? <div className="loading"></div> : null}
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        category:state.category,
        statuses:state.boxStatuses
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleBoxLoading
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PartReferenceBox)